import PageHeader from "../../../Header/PageHeader";
import ListReports from "../../../CostShowback/ListReports";

function CostShowbackReports() {
  return (
    <div>
      <PageHeader title="Cloud Cost Showback Reports" />
      <ListReports />
    </div>
  );
}

export default CostShowbackReports;
